import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { isBrowser } from 'react-device-detect';

import { I18n } from '../../utils/I18n';
import UserProtocol from '../../net/UserProtocol';
import AlertDialog from '../../utils/AlertDialog';

export default class Personal extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      Account: "",
      Email: "",
      UserName: "",
      Phone: "",
      Role: 0,
      Organization: "",
      currentPwd:"",
      NewPwd:"",
      ConfirmPwd:"",
      AuthoritieCheckBoxArray:[],
      oldDBPassword: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    console.log("Personal page init.");
  }

  componentDidMount () {
    // 這裡獲得個人資訊
    fetch("/api/account/info",{credentials: 'include'})
    .then(res => res.json())
    .then(
      (result) => {
  console.log("getAccountInfo:::");
  console.log(JSON.stringify(result));

  this.setState({Account: result.data.loginId});
  this.setState({Email: result.data.email});
  this.setState({UserName: result.data.name});
  this.setState({Phone: result.data.phone});
  if (result.data.roleId == null) {this.setState({Role:0})}
  else{this.setState({Role:result.data.roleId})};
  
 
  this.setState({oldDBPassword: result.data.password});
      },
      (error) => {
      console.log("error in getAccountInfo:",error)
      }
    );

    fetch("/api/company/permission/role/list", { credentials: 'include' })
      .then(res => res.json())
      .then(
        (result) => {
          console.log('現在開始拿role list:::');
          this.setState({ AuthoritieCheckBoxArray: result.data });
        },
        (error) => {
          console.log("role list錯誤:", error);
        }
      );



  }

  handleInputChange=(event)=>{
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({[name]: value});
  }


  handleRoleOption = () => {
    let node = [];
    this.state.AuthoritieCheckBoxArray.forEach(element =>
      node.push(<option value={element.id}>{element.name}</option>)
    )
    return (node)
  }




  render() {
    let columnClass = isBrowser ? "d-flex flex-row w-50" : "d-flex flex-row";

    return (
      <div className="p-4">
        <h4 style={{marginBottom: "30px"}}><b><u><FormattedMessage id="mainPage.users.personal" /></u></b></h4>
        <Form style={{width: isBrowser ? "80%":"100%"}}
        >
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="personal.account" /></span>
            <Form.Control type="text" size="sm" disabled defaultValue={this.state.Account} />
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="personal.currentPwd" /></span>
            <Form.Control type="password" size="sm" name="currentPwd" value={this.state.currentPwd} onChange={this.handleInputChange}/>
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="personal.newPwd" /></span>
            <Form.Control type="password" size="sm" name="NewPwd" value={this.state.NewPwd} onChange={this.handleInputChange}/>
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="personal.checkPwd" /></span>
            <Form.Control type="password" size="sm" name="ConfirmPwd" value={this.state.ConfirmPwd} onChange={this.handleInputChange} />
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="personal.email" /></span>
            <Form.Control type="email" size="sm" defaultValue={this.state.Email} name="Email" value={this.state.Email} onChange={this.handleInputChange}/>
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="personal.username" /></span>
            <Form.Control type="text" size="sm" defaultValue={this.state.UserName} name="UserName" value={this.state.UserName} onChange={this.handleInputChange}/>
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="personal.phone" /></span>
            <Form.Control type="tel" size="sm" defaultValue={this.state.Phone} name="Phone" value={this.state.Phone} onChange={this.handleInputChange}/>
          </div>
          <div className={columnClass} style={{marginBottom: "10px"}}>
            <span className="align-self-center" style={{width: "30%"}}><FormattedMessage id="personal.role.title" /></span>
            <div className="d-flex flex-row w-100 align-items-center">
              <Form.Control size="sm" as="select" id="permissionSelect" 
              defaultValue={this.state.Role}
              name="Role" value={this.state.Role} onChange={this.handleInputChange}   >
                <option value={0}>{I18n.t("userListPage.permis.void")}</option>
                {this.handleRoleOption()}
              </Form.Control>
 
            </div>
          </div>

          <Button variant="outline-dark" className="h-100" size="sm"
          
          // 點擊按鈕觸發驗證
          onClick={() =>{
            
            var url = '/api/account/edit';
            var data = {"loginId": this.state.Account,"password":this.state.currentPwd,"newPassword":this.state.NewPwd,"name":this.state.UserName,"phone":this.state.Phone,"email":this.state.Email,"roleId": this.state.Role};
            if (this.state.Account===""){
              AlertDialog.show(I18n.t("msg.PersonalInfo.PersonalInfo"), I18n.t("msg.createUser.ReplyAccountstrEmpty"));
              console.log("個人資料:帳號異常");
              return;
            };
            if (this.state.currentPwd===""){
              AlertDialog.show(I18n.t("msg.PersonalInfo.PersonalInfo"), I18n.t("msg.PersonalInfo.NowPasswordEmpty"));
              console.log("個人資料:當前密碼異常");
              return;
            };            

            //姓名
            if (this.state.UserName===""){
              AlertDialog.show(I18n.t("msg.PersonalInfo.PersonalInfo"), I18n.t("msg.createUser.ReplyNamestrEmpty"));
              console.log("個人資料:姓名異常");
              return;
            };


            //驗證Email
            const regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (!regex.test(this.state.Email)){
              AlertDialog.show(I18n.t("msg.PersonalInfo.PersonalInfo"), I18n.t("msg.createUser.ReplyEmailstrEmpty"));
              console.log("個人資料:驗證Email異常");
              return;
            };

            const reg0 = /^\d{5,12}$/;
            if (!reg0.test(this.state.Phone)){
              AlertDialog.show(I18n.t("msg.PersonalInfo.PersonalInfo"), I18n.t("msg.createUser.PhoneNumCheck"));
              console.log("個人資料:驗證電話異常");
              return;
            }
            if (this.state.NewPwd !== this.state.ConfirmPwd){
              AlertDialog.show(I18n.t("msg.PersonalInfo.PersonalInfo"), I18n.t("msg.createUser.ReplyConfirmPsd"));
              console.log("個人資料:新密碼與確認密碼不一致");
              return;
            }

            fetch(url, {
              method: 'POST', // or 'PUT'
              credentials: 'include',
              body: JSON.stringify(data), // data can be `string` or {object}!
              headers: new Headers({
                'Content-Type': 'application/json'
              })
            }).then(res => res.json())
            .catch(error => {console.error('Error:', error);
            AlertDialog.show(I18n.t("msg.PersonalInfo.PersonalInfo"), I18n.t("msg.PersonalInfo.UpdateInfo"));
          }
            
            )
            .then(response => {
              console.log('Edit PersonalInfo Success:', response);
          if (response.resultCode=="PASSWORD_NOT_MATCH"){
            AlertDialog.show(I18n.t("msg.PersonalInfo.PersonalInfo"), I18n.t("personal.PassAuthFail") );
          }
          else{AlertDialog.show(I18n.t("msg.PersonalInfo.PersonalInfo"), I18n.t("msg.PersonalInfo.UpdateInfo"));}
          });
        }}
            style={{ backgroundImage: "url('/images/button_bg2.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)" 
            ,marginLeft:"42%"}}>
            <FormattedMessage id="mainPage.users.edituser" /></Button>
        </Form>
      </div>
    );
  }
}